import {
  BulkValidCondenserPayloadType,
  ValidDuctlessSystemsInputType
} from 'data/types';

const replacerWithSortedKeys = () => {
  return (_key: string, value: unknown) => {
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.getPrototypeOf(value) === Object.prototype
    ) {
      const obj = value as Record<string, unknown>;
      return Object.keys(obj)
        .sort()
        .reduce<Record<string, unknown>>((acc, k) => {
          acc[k] = obj[k];
          return acc;
        }, {});
    }
    return value;
  };
};

export const buildStableHash = (body: unknown): string =>
  JSON.stringify(body, replacerWithSortedKeys());

export function buildPoolHash(
  systemInput: ValidDuctlessSystemsInputType
): string {
  return buildStableHash({
    ...systemInput,
    zones: systemInput.zones.map(({ selectedAirHandlerType, ...zone }) => zone)
  });
}

export function collectPoolHashes(
  payloads: ReadonlyArray<
    Pick<BulkValidCondenserPayloadType, 'condenserUniqueId' | 'fresh'>
  >
): Map<string, string> {
  const hashes = new Map<string, string>();
  payloads.forEach((payload) => {
    if (payload.fresh) {
      hashes.set(payload.condenserUniqueId, buildPoolHash(payload.fresh));
    }
  });
  return hashes;
}
